module.exports = __webpack_public_path__ + "img/tools.dce1151b.svg";